import React from 'react';
import ContextNavigation from './ContextNavigation';
import { contextNavigationParams } from './params';
import type { ContextNavigationNode } from './ContextNavigationLink';

interface ContextNavigationViewData {
  root_node?: ContextNavigationNode[];
  showSearchInput?: boolean;
  [key: string]: any;
}

export interface ContextNavigationViewProps {
  data?: ContextNavigationViewData;
}

// Só os parâmetros de navegação vão para o endpoint (e para a chave no Redux):
// o SSR monta a mesma chave com `contextNavigationParams`.
const ContextNavigationView: React.FC<ContextNavigationViewProps> = ({
  data = {},
}) => (
  <ContextNavigation
    params={contextNavigationParams(data)}
    showSearchInput={!!data.showSearchInput}
  />
);

export default ContextNavigationView;
